<script>
    import Icon from 'svelte-awesome'
    import { thumbsUp } from 'svelte-awesome/icons'
    import { Alert, Row, Col, Card, CardHeader, CardTitle, CardBody } from 'sveltestrap'
    import { InputCheckbox } from '@fno/component2/form.js'
    import FormSavingButtons from '../FormSavingButtons.svelte'
    import FormAlerts from '../FormAlerts.svelte'

    export let context
    export let saving
</script>

<h1>
    Features
</h1>
<Row>
    <Col xs="12" md="8" lg="6" xl="6">
        <p>
            Please select features you think you would like to configure for the app, this will be used as a guide once
            you are directed to the Portal.
        </p>
        <Alert color="info">
            <Icon data={thumbsUp} />
            You can change these features later, at any time.
        </Alert>
    </Col>
</Row>

<Row class="mb-3">
    <Col xs="12" md="8" lg="6" xl="8">
        <Card>
            <CardHeader>
                <CardTitle>Available Features</CardTitle>
            </CardHeader>
            <CardBody>
                {#each Object.keys(context.view.featuresSchema) as feature, index}
                    <Row class="mb-3">
                        <Col>
                            <InputCheckbox
                                {context}
                                {index}
                                formKey="clientOnboarding"
                                keypath={`attributes.steps.FEATURES.${feature}`}
                                label={context.view.featuresSchema[feature].label}
                                bind:value={context.form.clientOnboarding.attributes.steps.FEATURES[feature]}
                                on:change
                            />
                            <small class="ps-4 fw-light text-muted">
                                {context.view.featuresSchema[feature].description}
                            </small>
                        </Col>
                    </Row>
                {/each}
            </CardBody>
        </Card>
    </Col>
</Row>

<FormAlerts bind:alerts={context.alerts} />

<FormSavingButtons {context} {saving} on:save on:previousStepClicked on:nextStepClicked />
